import React, {Component} from 'react';
import {
    View,
    Image,
    Dimensions,
    TouchableOpacity,
    Animated,
    KeyboardAvoidingView,
    Platform,
    ScrollView, PermissionsAndroid, Linking, Alert
} from 'react-native';
import {moderateScale} from "../tools/Scaling"

import {connect} from "react-redux";
import HMImageView from "./HMImageView";
import * as NavigationService from "../redux/NavigationService";
import {Tools} from "../tools/Tools";
import store from "../redux/store";
import {serviceActionSetState} from "../screens/137/splash/action/ActionSplashGetAllData";
import DialogLoadingCustomize from "../customviews/DialogLoadingCustomize";

//import ParentScreen from "../ParentScreen";
import Colors from "../tools/Colors";
import Toast from "./toast";
import i18n from "../I18n/i18n";

let {width, height} = Dimensions.get('window');
width = Platform.OS === "web" ? (width > 480 ? 480 : width) : width;

const BaseUrliImage = "http://diyarman.ir/";

let container = null;

class HMListDiffSize extends Component {
    constructor(props) {
        super(props);

        container = this;
        this.state = {
            isLoading: false,
            index: -1,
            data: props.data,

            path: null,
            loaded: [],
            arrayRow: [],
            flagRow: false,
            countRow: 0,

            //    list:


        };
        /*     this.props.navigation.addListener('focus', () => {
                     this.setState({
                         isLoading: false,
                     })
                 }
             )
             this.props.navigation.addListener('blur', () => {
                 }
             )*/
    }

    render() {
        const {card, _main, data, title, _backgroundColorLoading} = this.props;
        let menus = store.getState().reducerSplashGetAllData && store.getState().reducerSplashGetAllData.results ? store.getState().reducerSplashGetAllData.results.menus : [];
        return (


            <View
                style={{
                    //position:'absolute',
                    flexDirection: "row",
                    flexWrap: 'wrap',
                    flex: 1,

                    flexGrow: 1,
                    alignItems: 'center', justifyContent: 'center',
                    //  backgroundColor: _main ? "#eee" : Colors.transparent,
                    //  backgroundColor: "#876a79",
                }}>


                {
                    (_main ? (menus) : this.state.data).map((item, key) => {
                            //  (this.state.data).find((obj) => obj.locale == i18n.locale).list.map((item, key) => {
                            let obj = {flag: false}
                            this.state.loaded.push(obj)
                            return (
                                //type=0 => پیوند ,type=1 => اخبار ,type=2 => صفحه ,type=3 => منو ,type=4 => اسلایدر ,type=5 => 137 یار ,type=6 => نقشه ,,type=7 => شکایات ,,type=8 =>  ارامستان ,
                                <TouchableOpacity
                                    key={key}
                                    onPress={() => {
                                        global.typeCategory = item.type;
                                        switch (parseFloat(item.type)) {

                                            case 0 :
                                                /*      if (item.id == 71) {
                                                          NavigationService.navigateParams("RegisterComplaintsScreen", {item})

                                                      } else*/
                                                //    Tools.GoLink(item.link_url)
                                                if (store.getState().reducerSplashGetAllData.Connection) {

                                                    // if (item.id == 123)
                                                    //     NavigationService.navigateParams("AdvancedSearchScreen", {item})
                                                    //   // NavigationService.navigateParams("GraveyardScreen", {item})
                                                    // else

                                                    if (item.login && !store.getState().reducerSplashGetAllData.token) {

                                                        store.dispatch(serviceActionSetState({
                                                            type: "WebViewScreen",
                                                            //   type: "InformationFanoosScreen",
                                                            item: item
                                                        }))
                                                        NavigationService.navigateParams('LoginStackScreen')
                                                    }
                                                    else {
                                                        // alert("bbbb")

                                                        NavigationService.navigateParams("WebViewScreen", {item: JSON.stringify(item)})
                                                        //NavigationService.navigateParams("InformationFanoosScreen", {item})

                                                    }
                                                }
                                                else {
                                                    // alert("fgfg")
                                                    //ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
                                                }
                                                break;


                                            case 1 :
                                                //  NavigationService.navigateParams("ListNewsScreen", {item: item,link_url:item.link_url,link_type:item.link_type,id:item.id,name:item.name})
                                                NavigationService.navigateParams("ListNewsScreen", {
                                                    item: JSON.stringify(item),

                                                })

                                                //   this.props.navigation.navigate("ListNewsScreen", {item})
                                                break;


                                            case 2 :
                                                Tools.GoLink(item.link_url)

                                                break;


                                            case 3 :
                                                NavigationService.navigateParams("CategoryScreen", {item: JSON.stringify(item)})

                                                break;


                                            case 4 :

                                                break;


                                            case 5 :
                                                let check = false;
                                                //let check = (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") && (!Tools.CheckValue(this.props.DataSplashScreen.TypeLogin) || this.props.DataSplashScreen.TypeLogin == 1);
                                                if (store.getState().reducerSplashGetAllData.token != null) {

                                                    NavigationService.navigateParams(check ? "ApplyParentScreen" : "ApplyScreen", {item: JSON.stringify(item),})

                                                    // NavigationService.navigateParams("ManInjamScreen", {item,})

                                                } else {
                                                    store.dispatch(serviceActionSetState({
                                                        type: check ? "ApplyParentScreen" : "ApplyScreen",
                                                        item: JSON.stringify(item)
                                                    }))
                                                    NavigationService.navigateParams('LoginStackScreen')

                                                }

                                                break;


                                            case 6 :
                                                NavigationService.navigateParams("ShowMap", {myLocation: true, item: item})

                                                // this.setState({isLoading: true, index: key}, () => {
                                                //     Tools.checkPermission(
                                                //         "ShowMap",
                                                //         item,
                                                //         key,
                                                //         this.goScreen,
                                                //         this.stateError
                                                //     )
                                                // })

                                                break;
                                            //competition
                                            case  7 :
                                                if (this.props.DataSplashScreen.TypeLogin == 1 || this.props.DataSplashScreen.TypeLogin == null)
                                                    NavigationService.navigateParams("ApplyScreen", {item: JSON.stringify(item)})
                                                else
                                                    Toast.show({
                                                        // type: 'success | error | info',
                                                        type: 'custom_info',
                                                        //  type: data.status ? 'custom_success' : 'custom_error',
                                                        //  position: 'top | bottom',
                                                        position: 'top',
                                                        text1: i18n.t('constant.message'),
                                                        text2: "شما به سامانه ۱۸۸۸ دسترسی ندارید ",
                                                        visibilityTime: 4000,
                                                        autoHide: true,
                                                        //  topOffset: 30,
                                                        // bottomOffset: 40,
                                                        onShow: () => {
                                                        },
                                                        onHide: () => {
                                                        }
                                                    })

                                                break;

                                            case  8 :
                                                NavigationService.navigateParams("AdvancedSearchScreen", {item})
                                                break;

                                            case  9 :
                                                if (!store.getState().reducerSplashGetAllData.token) {
                                                    store.dispatch(serviceActionSetState({
                                                        type: "CompetitionScreen",
                                                        //   type: "InformationFanoosScreen",
                                                        item: item
                                                    }))
                                                    NavigationService.navigateParams('LoginStackScreen')
                                                }
                                                else {
                                                    NavigationService.navigateParams("CompetitionScreen", {
                                                        item,
                                                        type: "CompetitionScreen"
                                                    });
                                                }

                                                break;
                                            case  11 :
                                                if (!store.getState().reducerSplashGetAllData.token) {
                                                    store.dispatch(serviceActionSetState({
                                                        type: "GalleryServiceScreen",
                                                        //   type: "InformationFanoosScreen",
                                                        item: item
                                                    }))
                                                    NavigationService.navigateParams('LoginStackScreen')
                                                }
                                                else {
                                                    NavigationService.navigateParams("GalleryServiceScreen", {
                                                        item,
                                                        type: "GalleryServiceScreen"
                                                    });
                                                }

                                                break;

                                            case  "satia1" :
                                                NavigationService.navigateParams("AdvancedSearchScreen", {item})
                                                break;
                                            case  "satia2" :
                                                NavigationService.navigateParams("AdvancedSearchScreen", {item})
                                                break;
                                            case  "satia3" :
                                                NavigationService.navigateParams("AdvancedSearchScreen", {item})
                                                break;
                                            case  "satia4" :
                                                NavigationService.navigateParams("AdvancedSearchScreen", {item})
                                                break;

                                            default:
                                                alert("")

                                        }
                                    }}
                                    style={{
                                        width: item.width ? (width / parseFloat(item.width == 0 ? 3.2 : item.width)) : width / moderateScale(1),
                                        height: item.height ? (width / parseFloat(item.height == 0 ? 3.2 : item.height)) : width / moderateScale(3.6),
                                        // padding: moderateScale(3),
                                        // backgroundColor: _main ? "#ffffff" : Colors.transparent,
                                        marginVertical: moderateScale(3),
                                        marginHorizontal: moderateScale(2),
                                        // marginBottom: moderateScale(1),
                                    }}
                                >


                                    {/*<View style={{width: "100%", height: '100%'}}>*/}

                                    {/*    <View style={{*/}
                                    {/*        flex:.75,*/}
                                    {/*        alignItems:'center',*/}
                                    {/*        justifyContent:'center'*/}
                                    {/*    }}>*/}

                                    {/*        <View style={{*/}
                                    {/*            width:(item.width ? (width / parseFloat(item.width == 0 ? 3.3 : item.width)) : width / moderateScale(1))/1.6,*/}
                                    {/*            height:(item.width ? (width / parseFloat(item.width == 0 ? 3.3 : item.width)) : width / moderateScale(1))/1.6,*/}
                                    {/*        }}>*/}
                                    {/*        <HMImageView*/}
                                    {/*            resizeMode={FastImage.resizeMode.contain}*/}
                                    {/*            _backgroundColorLoading={_backgroundColorLoading}*/}
                                    {/*            borderRadius={4}*/}
                                    {/*            // uriComplete={BaseUrliImage + item.imageUrl}*/}
                                    {/*            item={item}*/}
                                    {/*            //  requireDataaaa={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.func_switch(item.id) : false}*/}

                                    {/*            // requireData={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.state.path : false}*/}
                                    {/*            // uriComplete={item.thumbnail}*/}
                                    {/*            uriComplete={item.thumbnail}*/}

                                    {/*            text={title ? (item.name ? item.name : (item.title ? item.title : '')) : ''}*/}
                                    {/*            //  styleRoot={{backgroundColor: item.background_color ? Colors.transparent : "#d7011a"}}*/}
                                    {/*            styleText={{*/}
                                    {/*                marginTop: moderateScale(10),*/}
                                    {/*                textAlign: 'center',*/}
                                    {/*                color: item.font_color,*/}
                                    {/*                fontSize: title ? moderateScale(10) : moderateScale(14)*/}
                                    {/*            }}*/}
                                    {/*            styleImage={{borderRadius: moderateScale(7)}}*/}
                                    {/*            styleShadoBackground={{borderRadius: moderateScale(7)}}*/}
                                    {/*        />*/}
                                    {/*        </View>*/}
                                    {/*    </View>*/}

                                    {/*    <View style={{*/}
                                    {/*        flex:.25,*/}
                                    {/*        alignItems:'center'*/}
                                    {/*    }}>*/}
                                    {/*        <HMTextView*/}
                                    {/*            numberOfLines={1}*/}
                                    {/*            type={"bold"}*/}
                                    {/*            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}*/}
                                    {/*            text={item.name}*/}
                                    {/*            style={{*/}
                                    {/*                fontSize: moderateScale(10),*/}

                                    {/*                color: Colors.blackLight,*/}
                                    {/*                marginTop: moderateScale(4),*/}
                                    {/*                //  textAlign: "right",*/}
                                    {/*            }}/>*/}
                                    {/*    </View>*/}
                                    {/*</View>*/}


                                    <HMImageView
                                        card={card}
                                        resizeMode={"contain"}
                                        _backgroundColorLoading={_backgroundColorLoading}
                                        borderRadius={4}
                                        // uriComplete={BaseUrliImage + item.imageUrl}
                                        item={item}
                                        //  requireDataaaa={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.func_switch(item.id) : false}

                                        // requireData={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.state.path : false}
                                        // uriComplete={item.thumbnail}
                                        uriComplete={item.thumbnail}

                                        text={title ? (item.title ? item.title : '') : ''}
                                        //  styleRoot={{backgroundColor: item.background_color ? Colors.transparent : "#d7011a"}}
                                        styleText={{
                                            //marginTop: moderateScale(10),
                                            textAlign: 'center',
                                            color: item.font_color ? item.font_color : Colors.gray,
                                            fontSize: title ? moderateScale(9) : moderateScale(9)
                                        }}
                                        // styleImage={{borderRadius: moderateScale(7)}}
                                        //styleShadoBackground={{borderRadius: moderateScale(7)}}
                                    />

                                    {
                                        this.state.isLoading && key === this.state.index ?
                                            <DialogLoadingCustomize small/>
                                            : null
                                    }
                                    {/*
                                    <Image
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: moderateScale(8)

                                        }}
                                        resizeMode={"stretch"}
                                        //  source={require("../../../assets/img/mainAdvsPlaceholder.jpg")}
                                        source={
                                            this.state.loaded[key].flag === true ?
                                                {uri: BaseUrliImage + item.imageUrl}
                                                :
                                                require("../assets/img/logo.jpg")
                                        }
                                        rounded={moderateScale(15)}
                                        overlayAlpha={0.3}
                                        contentPosition={"center"}
                                        onLoad={() => this._onLoad(key)}
                                    >
                                    </Image>*/}


                                </TouchableOpacity>
                            ) //if you have a bunch of keys value pair

                        }
                    )
                }
            </View>

        )

    }

    _onLoad = (index) => {
        const {loaded} = this.state;

        if (loaded[index].flag === false) {
            loaded[index].flag = true;

            // update state
            this.setState({
                loaded,
            });
        }
    }


    goScreen(item, position) {
        if (container == null)
            alert('container==null')
        else
            container.setState({isLoading: false, index: -1},
                () => {
                    NavigationService.navigateParams("ShowMap", {item: item, position: position})

                }
            )
    }

    stateError() {
        if (container == null)
            alert('container==null')
        else
            container.setState({
                locationEnabled: false,
                isLoading: false,
                index: -1
            }, () => {
            })
    }

    ggggg() {
        alert(container.state.index);
    }

    /*  checkPermission(type, item, key) {
          let granted = false
          //  NavigationService.navigateParams("ShowMap", {item})
          this.setState({isLoading: true, index: key}, async () => {

              if (Platform.OS === 'android') {
                  granted = await PermissionsAndroid.requestMultiple(
                      [PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION],
                      {
                          title: 'Give Location Permission',
                          message: 'App needs location permission to find your position.'
                      }
                  )


                  if (granted) {
                      this.setState({}
                          , () => {
                              navigator.geolocation.getCurrentPosition(
                                  async (position) => {
                                      //do stuff with location
                                      this.setState({isLoading: false, index: -1})

                                      NavigationService.navigateParams(type, {item: position})

                                  },
                                  (error) => {
                                      if (error.code == 2)
                                          AndroidOpenSettings.locationSourceSettings()
                                      else {
                                          HMAlert(i18n.t('constant.message'), i18n.t('constant.retry'), [
                                                  // {text: 'Ask me later', onPress: () => {}},
                                                  // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                  {text: i18n.t('constant.ok'), onPress: () => {}},
                                              ],
                                              {cancelable: true}
                                          )
                                      }

                                      this.setState({
                                          locationEnabled: false,
                                          isLoading: false,
                                          index: -1
                                      }, () => {

                                      })
                                  },
                                  {enableHighAccuracy: true, timeout: 60000, maximumAge: 1000}
                              );
                          }
                      )


                  } else {
                      this.setState({isLoading: false, index: -1})

                  }
              } else {
                  navigator.geolocation.getCurrentPosition(
                      async (position) => {
                          //do stuff with location
                          this.setState({isLoading: false, index: -1})
                          NavigationService.navigateParams(type, {item: position})

                      },
                      (error) => {
                          Linking.openURL('app-settings:')
                          this.setState({
                              locationEnabled: false,
                              isLoading: false,
                              index: -1
                          }, () => {

                          })
                      },
                      {enableHighAccuracy: true, timeout: 20000, maximumAge: 1000}
                  );
              }

          })
      }*/
}

const mapStateToProps = (state) => {

    return {
        DataSplashScreen: state.reducerSplashGetAllData,


    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(HMListDiffSize);
